import * as React from 'react';
import CheckIcon from '@mui/icons-material/Check';

import { Message } from './Message';

export const Success: React.FC = () => (
  <Message>
    <div className="flex justify-center">
      <CheckIcon sx={{ color: 'darkgreen', fontSize: '80px' }} />
    </div>
    <h1>Your file has been successfully uploaded!</h1>
  </Message>
);
Success.displayName = 'Success';
